import { Grid } from 'antd';

const { useBreakpoint } = Grid;

function resolveDesktopBreakpoint(sm?: boolean) {
  if (typeof sm === 'boolean') {
    return sm;
  }

  if (
    typeof window !== 'undefined' &&
    typeof window.matchMedia === 'function'
  ) {
    return window.matchMedia('(min-width: 576px)').matches;
  }

  return false;
}

export function useIsDesktop() {
  const { sm } = useBreakpoint();
  return resolveDesktopBreakpoint(sm);
}
